import { render, staticRenderFns } from "./MenuBtns.vue?vue&type=template&id=59fc3e8a&scoped=true&"
import script from "./MenuBtns.vue?vue&type=script&lang=js&"
export * from "./MenuBtns.vue?vue&type=script&lang=js&"
import style0 from "./MenuBtns.vue?vue&type=style&index=0&id=59fc3e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fc3e8a",
  null
  
)

export default component.exports